<template>
  <div class="ProductionManagement">
    <AppHeader>课包管理</AppHeader>
    <AppBox class="appBox" id="appBox">
      <!--      <el-tabs v-model="activeName" @tab-click="changeTab">-->
      <!--        <el-tab-pane label="课程" name="zero"></el-tab-pane>-->
      <!--        <el-tab-pane label="题库" name="first"></el-tab-pane>-->
      <!--      </el-tabs>-->
      <template>
        <ProductionList :maxHeight="maxHeight"></ProductionList>
      </template>
      <!--      <template v-if="activeName === 'first'">-->
      <!--        <QuestionBankList></QuestionBankList>-->
      <!--      </template>-->
    </AppBox>
  </div>
</template>

<script>
import AppHeader from "@/components/ui/AppHeader/index.vue";
import AppBox from "@/components/ui/AppBox/index.vue";
import ProductionList from "@/pages/ProductionManagement/ProductionList.vue";
import QuestionBankList from "@/pages/ProductionManagement/QuestionBankList.vue";
import {mapActions, mapMutations, mapState} from "vuex";

export default {
  name: "ProductionManagement",
  components: {
    QuestionBankList,
    ProductionList,
    AppBox,
    AppHeader,
  },
  data() {
    return {
      activeName: "zero",
      maxHeight: null,
    };
  },
  computed: {
    ...mapState("teachingCenter", ["jumpWay", "isBack", "productList"]),
  },
  async mounted() {
    this.$nextTick(async () => {
      if (this.isBack) {
        if (this.jumpWay === 0) {
          this.activeName = "zero";
          await this.getProductResponseList({
            page: this.productList.page,
            size: this.productList.size,
          });
        } else {
          this.activeName = "first";
          await this.getProductQuestionBankList({
            page: this.productList.page,
            size: this.productList.size,
          });
        }
      }
      this.setData({key: "isBack", value: false});
    });
    this.handleResize();
    window.addEventListener("resize", this.handleResize);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.handleResize); // 移除resize事件监听
  },
  methods: {
    ...mapMutations("teachingCenter", ["setData"]),
    ...mapActions("teachingCenter", [
      "getProductResponseList",
      "getProductQuestionBankList",
    ]),
    async changeTab(val) {
      const number = Number(val.index);
      this.setData({key: "jumpWay", value: number});
    },
    handleResize() {
      this.$nextTick(() => {
        const el = document.getElementById("appBox");
        if (el.offsetHeight <= 650) {
          this.maxHeight = el.offsetHeight * 0.55;
        } else {
          this.maxHeight = el.offsetHeight * 0.6;
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.ProductionManagement {
  .appBox {
    height: calc(100vh - 155px);
    min-height: 330px;

    ::v-deep .el-tabs__item {
      color: #ff7918;
      padding: 0 30px 50px 30px;
      margin-left: 30px;
    }

    ::v-deep .el-tabs__item.is-active {
      background-color: #ff7918;
      padding: 0 30px;
      border-radius: 10px;
      color: #ffffff;
      margin-left: 30px;
    }

    ::v-deep .el-tabs__active-bar {
      margin-top: 10px;
      background-color: #e4e7ed;
    }
  }
}
</style>
